import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
const bonuses = ['GPT entrenado con más de $100,000,000 en cartas de venta reales', 'GPT para creativos (imágenes + videos + guiones IA)', 'GPT para escribir tu VSL', 'GPT para validar nichos y productos', 'GPT para generar ángulos de venta avanzados', 'Prompts completos del mastermind de $25,000/año', 'Prompts para crear productos digitales en minutos'];
export function Bonuses() {
  return <section className="py-20 bg-black text-white relative overflow-hidden" data-id="element-1">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-900/10 to-transparent" data-id="element-2" />

      <div className="relative max-w-6xl mx-auto px-6" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-4">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-5">
            <Icon name="sparkles" size={18} data-id="element-6" />
            Bono Black Friday
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-7">
            Todos los Custom Prompts + Los Custom GPTs del Bootcamp
          </h2>
          <p className="text-xl text-yellow-400 font-bold" data-id="element-8">Esto es oro puro.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/30 rounded-2xl p-8 md:p-12" data-id="element-9">
          <div className="mb-8" data-id="element-10">
            <h3 className="text-2xl font-bold text-yellow-400 mb-4" data-id="element-11">
              Acceso directo a:
            </h3>
          </div>

          <div className="grid gap-4" data-id="element-12">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3 + index * 0.05
          }} className="flex items-start gap-4 bg-black/50 rounded-lg p-4 border border-yellow-500/20" data-id="element-13">
                <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mt-0.5" data-id="element-14">
                  <Icon name="check" size={16} className="text-black" data-id="element-15" />
                </div>
                <p className="text-gray-200 font-medium leading-relaxed" data-id="element-16">
                  {bonus}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="mt-8 text-center" data-id="element-17">
            <div className="inline-block bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 border border-yellow-500/50 rounded-lg px-8 py-4" data-id="element-18">
              <div className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-19">
                Valor de los Bonos
              </div>
              <div className="text-3xl font-extrabold text-yellow-400" data-id="element-20">
                $25,000+
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}